import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box, Typography } from '@mui/material';
import { templateAtom, detailsAtom, stylesAtom } from '_state/signature';
import Template from '../../templates/template';

const EmailPreview = () => {
  const template = useRecoilValue(templateAtom);
  const details = useRecoilValue(detailsAtom);
  const styles = useRecoilValue(stylesAtom);

  return (
    <>
      <div className="signaturetoppreview">
        <span className="dangerColor"></span>
        <span className="infoColor"></span>
        <span className="successColor"></span>
      </div>
      <div className="signaturePreviewBar">
        <Typography>Send from: dilip@pulpy.io Dilip Kumar</Typography>
      </div>
      <div className="signaturePreviewBar">
        <Typography>Subject: Let's get new company email signatures</Typography>
      </div>
      <div className="signaturePreviewMessage">
        <Typography>
          Hi,
          <br />
          <br />
          Apparently, email signatures can mess up deliverability. Did you know that? News to me.
          <br />
          ---
        </Typography>
        <Box id="signatureMarkup">
          <Template details={details} styles={styles} template={template} />
        </Box>
      </div>
    </>
  );
};

export default EmailPreview;
